import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "tw-relative w-[30%]" };
const _hoisted_2 = { class: "tw-w-[252px] tw-hidden tw-bg-[#080e37] tw-fixed tw-top-0 tw-left-0 tw-z-40 tw-justify-end" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SidebarLiveNavigation = _resolveComponent("SidebarLiveNavigation");
    const _component_CircleX = _resolveComponent("CircleX");
    const _component_ArrowLeftFromLine = _resolveComponent("ArrowLeftFromLine");
    return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass(["header-section-categories tw-max-w-[380px] tw-min-w-[258px] tw-max-h-[calc(100vh-180px)] tw-overflow-auto tw-block", {
                    '': !$setup.isSidebarVisible,
                    'sidebar-open-left tw-h-[100vh] tw-fixed tw-left-0 tw-z-[9999999] tw-bg-[#080e37] tw-top-6': $setup.isSidebarVisible,
                }])
        }, [
            _createVNode(_component_SidebarLiveNavigation, { liveGameCategories: $props.liveGameCategories }, null, 8, ["liveGameCategories"]),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                    class: _normalizeClass(["tw-relative tw-right-2 tw-top-2 tw-text-[var(--foreground)]", { '': $setup.isSidebarVisible }]),
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => ($setup.toggleSidebar && $setup.toggleSidebar(...args)))
                }, [
                    _createVNode(_component_CircleX)
                ], 2)
            ])
        ], 2),
        _createElementVNode("button", {
            class: _normalizeClass(["tw-hidden tw-absolute tw-left-5 tw-top-0 secondary-sidebar-mob", { 'tw-hidden': $setup.isSidebarVisible }]),
            onClick: _cache[1] || (_cache[1] =
                //@ts-ignore
                (...args) => ($setup.toggleSidebar && $setup.toggleSidebar(...args)))
        }, [
            _createVNode(_component_ArrowLeftFromLine)
        ], 2)
    ]));
}
